// extracted by mini-css-extract-plugin
export var truncate = "_11-0";